import clsx from 'clsx'
import { type ComponentPropsWithoutRef, type FC } from 'react'

type Props = ComponentPropsWithoutRef<'div'>

export const ModalFooter: FC<Props> = ({ className, children, ...props }) => {
  return (
    <div
      {...props}
      className={clsx([
        'flex items-center justify-end gap-2 border-t border-gray-100 px-4 py-2',
        className
      ])}
    >
      {children}
    </div>
  )
}
